module.exports = __webpack_public_path__ + "img/tj.0aedb738.jpg";